import { apiClient } from '@/plugins/axios'; // Import your axios instance


const getRoles = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return await apiClient.get('/roles?include=permissions&' + params.toString()); 
};

const getRoleById = async (id: number) => {
  return await apiClient.get(`/roles/${id}`); 
};

const createRole = async (roleData: any) => {
  return await apiClient.post('/roles', roleData);
};

const updateRole = async (id: number, roleData: any) => {
  return await apiClient.patch(`/roles/${id}`, roleData); 
};

const deleteRole = async (id: number) => {
  return await apiClient.delete(`/roles/${id}`);
};

const getPermissions = async () => apiClient.get('/permissions');

const syncRolePermissions = async (roleId: number, permissions: string[]) =>
  apiClient.post(`/roles/${roleId}/sync_permissions`, { permissions });

export default {
    getRoles,
    getRoleById,
    createRole,
    updateRole,
    deleteRole,
    getPermissions,
    syncRolePermissions,
};
